import { combineReducers } from 'redux'
import member from './member'
import wines from './wines'
import orders from './orders'

export default combineReducers({
  member,
  wines,
  orders,
})